import { KnootLottie } from "@/_components/ui/lotties/Lottie";
import { Text } from "@chakra-ui/react";

interface PaymentLoadingProps {
  isLoading: boolean;
}

export const PaymentLoading = ({ isLoading }: PaymentLoadingProps) => {
  if (!isLoading) {
    return null;
  }

  return (
    <KnootLottie animationName="creditCardLoading" height="320px" width="320px">
      <Text textStyle="md" fontWeight="semibold">
        Initializing...
      </Text>
    </KnootLottie>
  );
};
